import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import * as DESUI from "react-bootstrap"; import Menubar from "../Menubar";
import { store } from "../../App"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import autoTable from "jspdf-autotable"; import { Modal, Row, Col, Container } from "react-bootstrap";
import KpiService from "../../Services/KpiService"; import { Button } from "reactstrap"; import { FaRegSave } from "react-icons/fa";
 import useAlert from "../Alert/useAlert"; import AlertModal from "../Alert/AlertModal";
import allowNumbersOnly, {  exportToentryExcel,   generateentryPdf, restrictToPasteOnlyMobileNumber } from "../utils/commonFunctions";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import Select from 'react-select';
import { RiEdit2Fill } from "react-icons/ri";
export default function HodLevelMandalMappOfficers() {
  let deptid =localStorage.getItem("deptid");
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();

  const [distlist, setDistlist] = useState([]); const [mandallist, setMandallist] = useState([]); const [ddolist, setDdolist] = useState(); const [orglist, setOrglist] = useState({});
  const [data, setData] = useState(); const [Empdata, setEmpdata] = useState([]); const [distEnb, setDistEnb] = useState(true); const [addModal, setAddModal] = useState(); const [searchText, setSearchText] = useState("");
  const [searchText1, setSearchText1] = useState(""); const [emplist, setEmplist] = useState({}); const [empmaplist, setEmpmaplist] = useState({})
  const [employeegetdata, setEmployeegetdata] = useState([]); const [editEmpdata, setEditEmpdata] = useState([]);
const [Index, setIndex] = useState([]); const[selecteddist,setSelecteddist] = useState(); const[selectedmandal,setSelectedmandal] = useState(); const [editenb, setEditenb] = useState(false); const [activeTab, setActiveTab] = useState("");
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");
  const formik = useFormik({
   
    initialValues: {
      district_id: "", 
      mandal_id:"",
      edit_mobile:"",
      list:[{district_id:"",user_id:"",org_id: "", ddo_code: "",emp_id:"",mandalId:"",cfmsid:"",fieldenb:false, ddocode_description:"",employee_name:"",org_name:"",
      alternate_mobile_no:""}] 
    },

  })
 
  React.useEffect(() => {
    if ((roleid === "2") || (roleid === "10") || (roleid === "3")) {
      setDistEnb(true);
    formik.setFieldValue("district_id", district);
mandaldata(district);

    }
    if (roleid === "5") {
      setDistEnb(false)
    formik.setFieldValue("district_id", "0");

    }

    // if (district !== "0") {
    //     MandalDdoData(district);
    // }
    
  }, [])

  const mandaldata=(dist)=>{
    formik.setFieldValue("mandal_id","");
    setEmpdata([]);
    if(!dist){return;}

    MandalDdoData(dist);
      let params = { district_id: dist };
            MasterService.getMandals(params)
              .then((mandalRes) => {
                if (mandalRes.data) {
                //   let filteredMandals = mandalRes.data.filter(
                //     (mandal) => !restrictedMandals.includes(mandal.value)
                //   );
      
                  let options = mandalRes.data.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.value}
                    </option>
                  ));
      
                  setMandallist(options);
                }
              }).catch((error) => {
                console.error("Error fetching mandals:", error);
                showAlertMessage("Error fetching mandals. Please try again.", "warning");
              }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
              })
  }

 const getemployeeData = (dist,mandal) => {
  let missingFields = [];
    if (!dist) missingFields.push("District");
    if (!mandal) missingFields.push("Mandal");

      if(missingFields.length > 0){
    const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
    showAlertMessage(errorMessage, "warning");
    return;
    }
  formik.values.list.map((item,index)=>{
  formik.setFieldValue(`list.[${index}].ddo_code`, ""); 
  formik.setFieldValue(`list.[${index}].org_id`, ""); 
  formik.setFieldValue(`list.[${index}].emp_id`, "");
  })
    let payload = {
        "userId": username,
            "distId": dist,
            "mandalId": mandal,
            "buttonType": "get",

        
    };
    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.getMandalsUsersList(payload)
    .then((res) => {
        if (res?.data?.SCODE === "01") {
            setEmpdata(res.data.SDESC);
            const data = res.data.SDESC;
            const updatedRows = data.map((item, index) => {
              // MandalDdoData(item.district_id, index); 
              return {
                  user_id: item.userid,
                  org_id: "",
                  ddo_code: "",
                  emp_id: "",
                  mandalId: item.mandal_id,
                  cfmsid: "",
                  fieldenb: false,
                  ddocode_description: "",
                  org_name: "",
                  employee_name: "",
                  alternate_mobile_no: "",
               
              };
          });
          formik.setFieldValue('list', updatedRows);
          // ✅ Set updated list in Formik while preserving existing values
          // formik.setFieldValue("list", (prevValues) =>
          //     prevValues.map((prevRow, index) => ({
          //         ...prevRow, // Retains previous values
          //         ...updatedRows[index], // Updates only necessary fields
          //     }))
          // );
                
                KpiService.getHodLevelMandalMappOfficers(payload).then((response) => {
                    if (response?.data?.SCODE === "01") {
                        setEmployeegetdata(response.data.dataList);

                        const matchedRows = data.map((descItem, index) => {
                            const match = response.data.dataList.find(respItem => respItem.user_id === descItem.userid);
                            console.log("respItem.user_id",descItem.userid, "match",match);
                            return match ? {
                                user_id: match.user_id,
                                // mandalId: match.mandal_id,
                                ddo_code: match.ddocode,
                                org_id: match.org_id,
                                emp_id: match.cfmsid,
                                cfmsid: match.cfmsid,
                                fieldenb:false,   
                                ddocode_description:match.ddocode_description,
                                org_name:match.org_name,
                                employee_name:match.emp_name,
                                alternate_mobile_no:match.alternate_mobile_no,

                            } : updatedRows[index];
                        });

                        console.log("matchedRows", matchedRows);
                        formik.setFieldValue('list', matchedRows);

                        matchedRows.forEach((row, index) => {
                          // console.log(`ddocode =`, row.ddo_code);
                          if (row.ddo_code && row.ddo_code.trim() != "") 
                      {
                        console.log("row.ddo_code",row.ddo_code);
                        formik.setFieldValue(`list[${index}].fieldenb`, true);
                          formik.setFieldValue(`list[${index}].ddo_code`, row.ddo_code);
                          formik.setFieldValue(`list[${index}].ddocode_description`, row.ddocode_description);
                          formik.setFieldValue(`list[${index}].org_id`, row.org_id);
                          formik.setFieldValue(`list[${index}].org_name`, row.org_name);
                          formik.setFieldValue(`list[${index}].emp_id`, row.cfmsid);
                          formik.setFieldValue(`list[${index}].employee_name`, row.employee_name);
                          formik.setFieldValue(`list[${index}].alternate_mobile_no`, row.alternate_mobile_no);
                       
                      }

                         else{
                          formik.setFieldValue(`list[${index}].fieldenb`, false);
                         } 
                      });
                      
            //             matchedRows.forEach((row, index) => {
            //               MandalOrgData(row.ddocode,index);
            // console.log(`list[${index}].org_id`, row.org_id);
            //                 formik.setFieldValue(`list[${index}].org_id`, row.org_id);
            //               // });
            
                        
            //                 console.log(`list[${index}].org_id`, parseInt(row.cfmsid));
            //                                 formik.setFieldValue(`list[${index}].emp_name`, parseInt(row.cfmsid));
            //                               });
                      
                    }
                });
           
          
          } else {
                const message = res?.data?.SDESC || "Unexpected response format.";
                console.warn("API Response Issue:", message, res?.data);
                showAlertMessage(message, "warning");
                setEmpdata([]);
            }
        }).catch((error) => {
            console.error("Error fetching data:", error);
            showAlertMessage("Error fetching data. Please try again.", "warning");
            setEmpdata([]);
        }).finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });

  
   
  


};
  

const geteditemployeeData = (detail,index) => {
  setSelectedmandal(detail.mandal_id);
  console.log("detail",detail);
  setEditenb(true);
  setIndex(index);
  console.log("index",index);
  // formik.values.list.map((item,index)=>{
  // formik.setFieldValue(`list.[${index}].ddo_code`, ""); 
  // formik.setFieldValue(`list.[${index}].org_id`, ""); 
  // formik.setFieldValue(`list.[${index}].emp_id`, "");
  // })
    let payload = {
      "deptId": deptid,
        "userId": detail.userid,
        "distId": detail.district_id,
        "mandalId":detail.mandal_id,
        "buttonType": "get"
    };
 store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getupdateEmpMappingDetails(payload)
    .then((res) => {
        if (res?.data?.SCODE === "01") {
            setEditEmpdata(res.data.dataList[0]);
            const data=res.data.dataList[0];
// console.log("detail.dist_id",data.dist_id);
           MandalDdoData(data.dist_id);
            // formik.setFieldValue(`list[${index}].ddo_code`,data.ddocode);
          //  MandalOrgData(data.ddocode,index);
            // formik.setFieldValue(`list[${index}].org_id`,data.org_id);
            //  EmployeeDetails(data.org_id,index);
            // formik.setFieldValue(`list[${index}].emp_id`,parseInt(data.cfmsid))
            // formik.setFieldValue(`list[${index}].alternate_mobile_no`,data.alternate_mobile_no);

            formik.setFieldValue(`list[${index}].ddo_code`,"");
            formik.setFieldValue(`list[${index}].org_id`,"");
            formik.setFieldValue(`list[${index}].emp_id`,"");
            formik.setFieldValue(`list[${index}].alternate_mobile_no`,"");
            setAddModal(true);
          
          } else {
                const message = res?.data?.SDESC || "Unexpected response format.";
                console.warn("API Response Issue:", message, res?.data);
                showAlertMessage(message, "warning");
            }
        }).catch((error) => {
            console.error("Error fetching data:", error);
            showAlertMessage("Error fetching data. Please try again.", "warning");
        }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
              })

  
   
  


};
  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    MasterService.getDistricts().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setDistlist(options);
      }
    });
    // getemployeeData()
    // MandalDdoData(district)
    store.dispatch({ type: "HIDE_SPINNER" });
  }, []);
 function validateMobileNumber(mobile) {
  if(!mobile){
      return;
    }
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(mobile)) {
        showAlertMessage("Invalid mobile number! It should start with 6-9 and be 10 digits long.","warning");
      return false;
    }
    return true;
  }


  const MandalDdoData = (district) => {
    setDdolist([])
    if(!district){return;}
setSelecteddist(district);
    store.dispatch({ type: "SHOW_SPINNER" });
  
    // formik.setFieldValue("ddo_code", "")
    // formik.setFieldValue(`list.[${index}].ddo_code`, ""); 
    // formik.setFieldValue(`list.[${index}].org_id`, ""); 
    // formik.setFieldValue(`list.[${index}].emp_name`, ""); 
    let params = { "deptId": localStorage.getItem("deptid"), "distCode": parseInt(district), "userId":username, }
    KpiService.getDdolist(params).then((res) => {
    store.dispatch({ type: "HIDE_SPINNER" });

      if (res.data.SCODE == "01") {
        let options = res.data?.SDESC.map((item, i) => {
          return (
            <option key={i} value={item.ddocode}> {item.ddocode_description} </option>
          );
        });
        console.log("options",options);
        setDdolist(res.data?.SDESC);
        // setDdolist((prev) => ({ ...prev, [index]: res.data?.SDESC })); 

      }
    });
  }


const MandalOrgData = (val, index) => {
    // const selectedDdoCode = e.target.value;
    if(val===""){
      return;
    }
    formik.setFieldValue(`list.[${index}].org_id`, ""); 
    formik.setFieldValue(`list.[${index}].emp_id`, ""); 
    setOrglist((prev) => ({ ...prev, [index]: [] })); 
  
    let params = {
      ddoCode: val,
      userId: username,
    };
  
    store.dispatch({ type: "SHOW_SPINNER" });
  
    KpiService.getOrglist(params)
      .then((res) => {
        if (res.data.SCODE == "01") {
          let options = res.data.SDESC.map((item, i) => (
            <option key={i} value={item.org_id}>
              {item.org_name}
            </option>
          ));
          console.log("Updated orglist:", { ...orglist, [index]: options });
  
          setOrglist((prev) => ({ ...prev, [index]: res.data.SDESC })); 
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
 const EmployeeDetails = (val,index) => {
  if(val===""){
    return;
  }
    let params = {  "orgId": val }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getemployees(params).then((res)=>{
      store.dispatch({ type: "HIDE_SPINNER" });
      if (res.data && res.data.SCODE === "01") {
        
            let options = res.data.EMP_DATA?.map((item, i) => (
              <option key={i} value={item.cfms_id}>
                {item.emp_name}
              </option>
            ));

  
            setEmplist((prev) => ({ ...prev, [index]: res.data.EMP_DATA })); 
        }
      // else { 
      //   // showAlertMessage(res.data.SDESC, "warning") 
      // }
    //   setAddModal(true)

    }).catch((error) => {
      console.error("Error saving data:", error);
      showAlertMessage("No data.", "warning");
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) });
  }


  const getEmployeeMapdata = (ord_id, empid, i) => {
    if(!ord_id || empid ===""){return;}

    let params = { orgId: ord_id };
    console.log("empid", empid);
  
    KpiService.getEmplist(params)
      .then((res) => {
        if (res?.data?.SCODE === "01") {

          res.data.EMP_DATA?.forEach((item) => {
            if (item.cfms_id == empid) {
              setEmpmaplist((prev) => ({ ...prev, [i]: item })); 
            }
          });
        } else {
          const message = res?.data?.SDESC || "Unexpected response format.";
          console.warn("API Response Issue:", message, res?.data);
          showAlertMessage(message, "warning");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        showAlertMessage("Error fetching data. Please try again.", "warning");
      });
  };
  

  const searchColumns = ["position_name", "name", "cfms_id", "mobileno","employeeid","dob","gender_desc"];
  const normalSearchText = searchText.trim().toLowerCase();
  // const filteredData =
  //   normalSearchText.length > 0 && data?.length ? data.filter((item) => { return ( item &&
  //           searchColumns.some((key) => { const value = item[key]; return ( value !== null && value !== undefined && value.toString().toLowerCase().includes(normalSearchText) ); })
  //         );}): data;
  
      const filteredDataa =
      searchText1.length > 0 && Empdata?.length
        ? Empdata.filter((item) => {
            return(item && Object.keys(item).some((key) => { const value = item[key];
              return ( value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()) ); }) );
          }) : Empdata;
  const [selectedIndex, setSelectedIndex] = useState(null);

 


// const handleCheckboxChange = (index) => {
//   if (selectedIndex === index) { setSelectedIndex(null); } 
//   else { setSelectedIndex(index); }
// }

const handleClose = () => {
  setAddModal(false);
        setEditenb(false);
  setActiveTab("");
  formik.setFieldValue("edit_mobile", "");

  // formik.setValues(prevValues => ({ ...Object.keys(prevValues).reduce((acc, key) => { acc[key] = key === 'district_id' ? prevValues[key] : ''; return acc; }, {}) }));
  // setOrglist([]); setSelectedIndex(null); setSearchText("");
};

const changemobile = () => {
  if (!validateMobileNumber(formik.values.edit_mobile)) {
    return;
  }

  const payload = {
    hodId: localStorage.getItem("hod_id"),
    ulbId: "0",
    deptId: deptid,
    orgId: editEmpdata?.org_id,
    positionId: editEmpdata?.position_id,
    ddoCode: editEmpdata?.ddocode,
    cfmsId: editEmpdata?.cfmsid,
    distId: editEmpdata?.dist_id,
    mandalId: selectedmandal,
    dateOfBirth: editEmpdata?.date_of_birth,
    mobileNumber: editEmpdata?.mobile_number,
    alternateMobileNo: formik.values.edit_mobile,
    mobileNumbers: [editEmpdata?.mobile_number, formik.values.edit_mobile],
    gender: editEmpdata?.gender,
    empName: editEmpdata?.emp_name,
    empId: editEmpdata?.emp_id,
    userId: username,

  };

  store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.editEmpMobileNo(payload)
    .then((res) => {
      if (res.data) {
        showAlertMessage(res.data.SDESC, res.data.SCODE === "01" ? "success" : "warning", () => {
          if (res.data.SCODE === "01") {
            getemployeeData(formik.values.district_id, formik.values.mandal_id);
          }
        });
      }
    })
    .catch((error) => {
      console.error("Error updating mobile number:", error);
      showAlertMessage("Failed to update mobile number.", "warning");
    })
    .finally(() => {
      formik.setFieldValue("edit_mobile", "");
      setActiveTab("");
      setAddModal(false);
      setEditenb(false);
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};


const SaveData = (emp,mobile,i) => {
  let missingFields = [];
  if (!formik.values.district_id) missingFields.push("District");
  if (!formik.values.mandal_id) missingFields.push("Mandal");
    if (!formik.values.list[i].ddo_code) missingFields.push("DDO Code");
    if (!formik.values.list[i].org_id) missingFields.push("Organization Id");
    if (!formik.values.list[i].emp_id) missingFields.push("Employee Id");

        if(missingFields.length > 0){
            const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
            showAlertMessage(errorMessage, "warning");
            return;
            }

           validateMobileNumber(formik.values.list[i].alternate_mobile_no);
            if (editenb) {
  if (!formik.values.list[i].alternate_mobile_no) { 
     showAlertMessage("Please Enter Alternate Mobile Number", "warning");
     return;
      }
    }
  const payload = {
    userId:username,
...editenb ?{deptId:deptid}:{},
    distId:selecteddist,
  //  deptId:localStorage.getItem("deptid"),
 buttonType:"save",
     mandalId:selectedmandal,
  ddoCode:emp.ddocode,
   orgId:emp.org_id,
    cfmsId:emp.cfms_id,
    positionId:emp.position_id,
    mobileNumber:emp.mobileno,
   empId:emp.employeeid,
    gender:emp.gender_desc,
   empName:emp.name,
   alternateMobileNo:mobile,
   mobileNumbers:[emp.mobileno,mobile],
   ulbId:"0"

  };
  store.dispatch({ type: "SHOW_SPINNER" });
   const serviceCall = editenb
      ? KpiService.updateEmpMappingDetails(payload)
      : KpiService.getHodLevelMandalMappOfficers(payload);
   serviceCall.then((res)=>{
      if(res.data) {
        showAlertMessage(res.data.SDESC,res.data.SCODE==="01"? "success":"warning" ,  () => {
          formik.values.list?.forEach(index=>{
            setOrglist((prev) => ({ ...prev, [index]: [] })); 
            setEmplist((prev) => ({ ...prev, [index]: [] })); 
          })
         {res.data.SCODE==="01" && getemployeeData(formik.values.district_id,formik.values.mandal_id)}

            // getemployeeData();setAddModal(false);
            // formik.setValues(prevValues => ({
            //   ...Object.keys(prevValues).reduce((acc, key) => {
            //     acc[key] = key === 'district_id' ? prevValues[key] : '';
            //     return acc;
            //   }, {})
            // }));setOrglist([]);setSelectedIndex(null);

          })
      }}).catch((error) => {
        console.error("Error saving data:", error);
        showAlertMessage("Failed to save data.", "warning");
      }).finally(() => {
        setAddModal(false);
        setEditenb(false);
    store.dispatch({ type: "HIDE_SPINNER" });
  });
  }

return (
  <>
    <Menubar />
    <Container fluid  style={{width:"95%"}} className='map-header'>
      <div className='sa-title'>
        <h2>Mandal Employee  <span> Mapping</span></h2>
      </div>
    </Container>

    <DESUI.Container fluid className="outer-page-content-container" style={{width: "95%", height: "1100px", overflow: "visible" }}>
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>

          <div className='mandal-container p-4 mt-2'>

            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="district_id" onChange={(e) => {mandaldata(e.target.value);formik.handleChange(e)}} disabled={distEnb} className="form-control" 
                 > 
                <option value="">--Select--</option>  {distlist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                <label className="mb-1 fw-bold">MANDAL</label> <span style={{ color: "red" }}> *</span>
                <Field component="select" name="mandal_id" className="form-control" onChange={(e) => {getemployeeData(formik.values.district_id,e.target.value);formik.handleChange(e) }} > <option value="">--Select--</option>
                <option value="0">All</option> {mandallist} </Field>
                <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="mandal_id" /> </span>
              </Col>

             
            </Row>
          </div>
        <br />
     

      <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "200px", minWidth: "200px", }}
                onFocus={(e) => {
                  e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "200px";
                }}
              >
                <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                <input type="text" placeholder="Search " value={searchText1}
                  onChange={(event) => setSearchText1(event.target.value)}
                  style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
              </div>
            </Col>
             <Col className=" mb-2 " >
                                                  <button className="btn btn-danger btn-sm mx-2 pdf-btn" type="button" onClick={()=>generateentryPdf("my-table",formik.values,"MandalMappedUserdetails")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                                  <button
                                                  type="button"
                                                      variant="success"
                                                      size="sm"
                                                      className="btn mx-2 excel-btn"
                                                      style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                                                      onClick={() => exportToentryExcel("my-table", formik.values,"MandalMappedUserdetails")}
                                                  >
                                                      Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                                                  </button>
                                              </Col>
          </Row>
          {/* <div id="table-scroll"className="table-scroll">
            <div className="table-wrap"> */}
             <div id="table-scroll"  style={{ maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden' }} >
            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
              <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                
                <tr className="text-center">
                <th colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}><span style={{color: "orange" }}>Mandal Mapped User Details </span> </th></tr>
                <tr className="text-center">
                  <th> Sl No. </th> 
                   <th> User Id </th>
                  <th> Mandal  </th>
       
                  <th style={{width:"20%" }} >DDO Name   </th> 
                    <th> Organization Name </th>
                    <th> Employee Name </th>
                    <th> Alternate Number </th>
                    <th> Map Mandal Officers </th>
                 
                </tr>
              </thead>
              <tbody>
                {filteredDataa?.length === 0 || filteredDataa?.length === undefined ? (
                  <tr>
                    <td className="text-center" colSpan="8">
                      <b style={{ color: "red" }}>Details Not Found</b>
                    </td>
                  </tr>
                 ) : (
                  filteredDataa.map((detail, i) => {
                    // Find the actual index in Empdata
                    const actualIndex = Empdata.findIndex((emp) => emp.userid === detail.userid);

      return (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td> 
                          {/* <td style={{ textAlign: "left" }}>{detail.cfmsid ? detail.cfmsid : ""}</td> */}
                          <td style={{ textAlign: "left" }}>{detail.userid}</td>
                          <td style={{ textAlign: "left" }}>{detail.mandal_name}</td>
                       
                          <td style={{ textAlign: "left" }}>
      {formik.values.list[actualIndex].ddocode_description ?<Field type="text" name={`list.[${actualIndex}].ddocode_description`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb}
                 
            />:
 
       <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${actualIndex}].ddo_code`}
                                    required={true}
                                    getOptionValue={(option) => option.ddocode}
                                    getOptionLabel={(option) => option.ddocode_description}
                                    options={ddolist}
                                    value={ddolist?.find((option) => option.ddocode === formik.values.list[actualIndex].ddo_code) || ""}
                                    onChange={(option) => {
                                     setSelectedmandal(detail.mandal_id);
                                     MandalOrgData(option ? option.ddocode : "",actualIndex);
                                      formik.setFieldValue(`list.[${actualIndex}].ddo_code`,option ? option.ddocode : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1000 }),
              }}
                                  />
      }
                          </td>
                          <td style={{ textAlign: "left" }}>
                              {formik.values.list[actualIndex].org_name ?<Field type="text" name={`list.[${actualIndex}].org_name`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb}
                                        
                                        />:

      <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${actualIndex}].org_id`}
                                    required={true}
                                    getOptionValue={(option) => option.org_id}
                                    getOptionLabel={(option) => option.org_name}
                                    options={orglist[actualIndex]}
                                    value={orglist[actualIndex]?.find((option) => option.org_id === formik.values.list[actualIndex].org_id) || ""}
                                    onChange={(option) => {
                                     EmployeeDetails(option ? option.org_id : "",actualIndex);
                                      formik.setFieldValue(`list.[${actualIndex}].org_id`,option ? option.org_id : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1000 }),
              }}
                                  />
    }
  </td>

  <td style={{ textAlign: "left" }}>
     {formik.values.list[actualIndex].employee_name ?<Field type="text" name={`list.[${actualIndex}].employee_name`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb}
                
                />:

     <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${actualIndex}].emp_id`}
                                    required={true}
                                    getOptionValue={(option) => option.cfms_id}
                                    getOptionLabel={(option) => option.emp_name}
                                    options={emplist[actualIndex]}
                                    value={emplist[actualIndex]?.find((option) => option.cfms_id === formik.values.list[actualIndex].emp_id) || ""}
                                    onChange={(option) => {
                                      getEmployeeMapdata(formik.values.list[actualIndex].org_id,option ? option.cfms_id : "", actualIndex);
                                      formik.setFieldValue(`list.[${actualIndex}].emp_id`,option ? option.cfms_id : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1000 }),
              }}
                                  />
    }
  </td>

   <td style={{ textAlign: "left" }}>
     {/* {formik.values.list[actualIndex].alternate_mobile_no ?<Field type="text" name={`list.[${actualIndex}].alternate_mobile_no`} className="form-control"  disabled={formik.values.list[actualIndex].fieldenb} */}
                
                {/* />: */}
    <Field
     type="text"
      name={`list.[${actualIndex}].alternate_mobile_no`}
      className="form-control"
       onBlur={(e) => {validateMobileNumber(e.target.value);formik.handleChange(e)} }
                                                        maxLength="10" onKeyPress={(e) =>{allowNumbersOnly(e)}}
    
                                                        disabled={formik.values.list[actualIndex].fieldenb}/>

    {/* } */}
  </td>
  <td style={{ textAlign: "center" }}>
  {!formik.values.list[actualIndex].fieldenb ?
<Button
  variant=""
  size="sm"
  className="map-btn"
  onClick={() => {console.log("i,actualIndex",i,actualIndex);SaveData(empmaplist[actualIndex],formik.values.list[actualIndex].alternate_mobile_no,actualIndex)}}  // ✅ Pass only the data at index `i`
  
>
  Map <FaRegSave className="ms-1 s-icon" />
</Button>
:
<RiEdit2Fill style={{color:"#0f7e46",cursor:"pointer"}} size="30px"  onClick={()=>{geteditemployeeData(detail,actualIndex);}}/>
 } 
</td>

            

                        </tr>
                     );
                     
                    })
                  )}
              </tbody>

            </table>

          

</div>
          {/* </div> */}
          {/* <div style={{textAlign:"center",marginTop:"5px"}}>
            <Button variant="" size="sm" className="map-btn" onClick={() => SaveData()}> Save<FaRegSave className="ms-1 s-icon" /></Button>

            </div> */}
 <Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={addModal} >
                                            <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <Modal.Title style={{ margin: "0 auto" }}>Edit Employee Details</Modal.Title>
                                                                                          <span role="button" tabIndex="0" aria-label="Close" onClick={handleClose} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose(); } }} style={{ cursor: "pointer" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <FormikProvider value={formik} >
                                                    <Form onSubmit={formik.handleSubmit}>
                                                        <div className='mandal-container p-4 '>
                                                                  <Row >
                                                                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                          <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Cfms Id</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.cfmsid}
                                                           </p>
                                                         </div>
                                                       
                                                                                                         
                                                                                                       </Col>
                                                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                      <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">District</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.district_name}
                                                           </p>
                                                         </div>
                                                                                                          
                                                                                                         
                                                                                                       </Col>
                                                                                                      <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">  
                                                                                                      <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">User Id</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.user_id}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                      
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                        <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Position Id
                                                       </label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.position_id}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                        <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Designation</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.position_name}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                        <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Employee Name</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.emp_name}
                                                           </p>
                                                         </div>
                                                          
                                                                                                       </Col>
                                                                                                       <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                        <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Mobile</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.mobile_number}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                
                                                                                                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                                                                                                    <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Alternate Mobile</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.alternate_mobile_no}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                         <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} >
                                                                                                          <div className="d-flex flex-column">
                                                           <label className="mb-1 fw-bold">Working Office</label>
                                                           <p  style={{ color: "#6e4747" }}>
                                                             {editEmpdata.working_office}
                                                           </p>
                                                         </div>
                                                                                                       </Col>
                                                                                                       </Row>
                                                                                                       </div>
                                                        
                                                        <div className="d-flex justify-content-left ">
  <div className="form-check form-check-inline"> <input className="form-check-input" type="radio" name="employeeOption" id="editEmployeeDetails" onChange={() => setActiveTab("edit")} /> <label className="form-check-label" htmlFor="editEmployeeDetails" style={{ fontSize: "18px" }}> Edit Employee Details </label> </div>

  <div className="form-check form-check-inline">
    <input className="form-check-input" type="radio" name="employeeOption" id="changeEmployee" onChange={() => {setActiveTab("changeemp");formik.setFieldValue("edit_mobile","");}} /> <label className="form-check-label" htmlFor="changeEmployee" style={{ fontSize: "18px" }}> Change Employee </label>
  </div> </div>
{activeTab === "edit" && <div className="rounded-2 mt-3" style={{ border: "1px solid #ccc", padding: "16px", marginBottom: "20px", position: "relative" }}> <div style={{ position: "absolute", top: "-16px", left: "10px", backgroundColor: "white", color: "#aa1313", padding: "4px 12px", fontSize: "16px", fontWeight: "bold", }} > Edit Employee Details </div> <Row> <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}> <label className="mb-1 fw-bold">Alternate Mobile</label> <Field autoComplete="off" name="edit_mobile" className="form-control" onBlur={(e) => { validateMobileNumber(e.target.value); formik.handleChange(e); }} type="text" maxLength="10" onKeyPress={(e) => { allowNumbersOnly(e); }} {...restrictToPasteOnlyMobileNumber(formik,"edit_mobile")} /> </Col></Row> <div style={{ textAlign: "center" }} className="bottom-buttons mt-1"> <Button variant="" size="sm" className="save-btn" onClick={changemobile}> Update<FaRegSave className="ms-1 s-icon" /> </Button> </div></div> }

                                                        {activeTab === "changeemp" &&<>
                                                           <Row className="mt-2 ">
                                                          <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" >
                              <label className="mb-1 fw-bold"> DDO NAME </label> <span style={{ color: "red" }}> *</span>
                               <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${Index}].ddo_code`}
                                    required={true}
                                    getOptionValue={(option) => option.ddocode}
                                    getOptionLabel={(option) => option.ddocode_description}
                                    options={ddolist}
                                    value={ddolist?.find((option) => option.ddocode === formik.values.list[Index]?.ddo_code) || ""}
                                    onChange={(option) => {
                                     MandalOrgData(option ? option.ddocode : "",Index);
                                      formik.setFieldValue(`list.[${Index}].ddo_code`,option ? option.ddocode : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                                        />
                             
                              <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="ddo_code" /> </span>
                            </Col>
            
                            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" >
                              <label className="mb-1 fw-bold"> ORGANIZATION NAME </label> <span style={{ color: "red" }}> *</span>
                         
                           <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${Index}].org_id`}
                                    required={true}
                                    getOptionValue={(option) => option.org_id}
                                    getOptionLabel={(option) => option.org_name}
                                    options={orglist[Index]}
                                    value={orglist[Index]?.find((option) => option.org_id === formik.values?.list[Index]?.org_id) || ""}
                                    onChange={(option) => {
                                     EmployeeDetails(option ? option.org_id : "",Index);
                                      formik.setFieldValue(`list.[${Index}].org_id`,option ? option.org_id : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
                                  />
                                  </Col>
                                  <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" >
                              <label className="mb-1 fw-bold"> EMPLOYEE NAME </label> <span style={{ color: "red" }}> *</span>
                         
                         <Select
                                    className="w-100"
                                    isClearable={true}
                                    isSearchable={true}
                                    name={`list.[${Index}].emp_id`}
                                    required={true}
                                    getOptionValue={(option) => option.cfms_id}
                                    getOptionLabel={(option) => option.emp_name}
                                    options={emplist[Index]}
                                    value={emplist[Index]?.find((option) => option.cfms_id === formik.values.list[Index]?.emp_id) || ""}
                                    onChange={(option) => {
                                      getEmployeeMapdata(formik.values.list[Index].org_id,option ? option.cfms_id : "", Index);
                                      formik.setFieldValue(`list.[${Index}].emp_id`,option ? option.cfms_id : "")
                                      // if (additionalOnChange) additionalOnChange(option);
                                    }}
                                    
                                    isDisabled={false}
                                menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
                                  />
                                  </Col>
                                     <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mandal-col mb-2" >
                                       <label className="mb-1 fw-bold"> ALTERNATE MOBILE </label> <span style={{ color: "red" }}> *</span>
                                      <Field
     type="text"
      name={`list.[${Index}].alternate_mobile_no`}
      className="form-control"
       onBlur={(e) => {validateMobileNumber(e.target.value);formik.handleChange(e)} }
                                                        maxLength="10" onKeyPress={(e) =>{allowNumbersOnly(e)}}
    
                                                       /></Col>
                              <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="org_id" /> </span>
                            {/* </Col> */}
                                         <div className="bottom-buttons justify-content-center d-flex  mb-1">
                                                <Button variant="" size="sm" className="save-btn me-4"  type="button"
                                                onClick={()=>{SaveData(empmaplist[Index],formik.values.list[Index].alternate_mobile_no,Index)}}
                                                >
                              Update <FaRegSave className="ms-1 s-icon" />
                            </Button></div>                   
                                                         
                        
                                                        </Row>
                                                        </>}
                                                    </Form>
                                                </FormikProvider>
                                                <Row className="text-start mt-3 mx-1">
                                                   
                                                </Row>
                                            </Modal.Body>
                                        </Modal>
          </Form>
      </FormikProvider>
     <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    
    </DESUI.Container >
  </>
);
};



